"use strict";
/** Схемы доступа к аккаунтам и фильтров финансов. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.financeFilterSchema = exports.updateAccountAccessSchema = exports.grantAccountAccessSchema = void 0;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
const common_1 = require("./common");
// --- Доступ к аккаунтам --------------------------------------------------
/**
 * Выдача доступа к аккаунту.
 *
 * Схема намеренно не содержит ни одного поля, куда можно было бы вписать
 * пароль или ключ: `notes` предназначено для организационных пометок вида
 * «доступ выдан на время миграции».
 */
exports.grantAccountAccessSchema = zod_1.z.object({
    userId: common_1.uuidSchema,
    accessLevel: zod_1.z.enum(contracts_1.ACCOUNT_ACCESS_LEVELS),
    notes: zod_1.z.string().trim().max(1000, 'Примечание слишком длинное').optional().nullable(),
});
exports.updateAccountAccessSchema = zod_1.z.object({
    accessLevel: zod_1.z.enum(contracts_1.ACCOUNT_ACCESS_LEVELS).optional(),
    notes: zod_1.z.string().trim().max(1000).optional().nullable(),
});
// --- Финансы -------------------------------------------------------------
exports.financeFilterSchema = zod_1.z.object({
    currency: zod_1.z.preprocess((raw) => (raw === '' || raw === null ? undefined : raw), zod_1.z.enum(contracts_1.CURRENCIES).optional()),
    category: zod_1.z.preprocess((raw) => (raw === '' || raw === null ? undefined : raw), zod_1.z.enum(contracts_1.EXPENSE_CATEGORIES).optional()),
    /** Показывать отменённые расходы. По умолчанию их не видно. */
    includeCancelled: zod_1.z.preprocess((raw) => raw === true || raw === 'true', zod_1.z.boolean().default(false)),
});
//# sourceMappingURL=resources.js.map